
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z","fill":"#F8F8FA"}}),_c('path',{attrs:{"d":"M26.875 15C26.875 18.797 23.797 21.875 20 21.875C16.203 21.875 13.125 18.797 13.125 15C13.125 11.203 16.203 8.125 20 8.125C23.797 8.125 26.875 11.203 26.875 15Z"}}),_c('path',{attrs:{"d":"M7.54456 32.2928C9.73885 27.6147 14.4911 24.375 20 24.375C25.5089 24.375 30.2611 27.6147 32.4554 32.2928C29.2823 35.5076 24.8738 37.5 20 37.5C15.1261 37.5 10.7176 35.5076 7.54456 32.2928Z"}})])
          )
        }
      }
    